import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    position: "relative",
  },
  videoContent: {
    display: "grid",
    height: "100%",
    gridGap: theme.spacing(1),
  },
  caption: {
    top: 0,
    position: "absolute",
    left: 0,
    right: 0,
    textAlign: "center",
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0.85) 10%, rgba(0,0,0,0) 100%)",
    paddingBottom: theme.spacing(2),
    color: "#fff",
    display: "flex",
    alignItems: "center",
  },
  cationLabel: {
    flexGrow: 1,
  },
  player: {
    maxWidth: "100%",
    width: "100%",
    position: "absolute",
    height: "100%",
    border: "0",
    allowfullscreen: "true",
  },
  iframeContent: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
}));

const VehiclePlaybackIframe = ({ sources }) => {
  const classes = useStyles();
  const iframeSrc = sources?.find((x) => x.type === "iframe")?.source;
  if (!iframeSrc) {
    return <video poster="/live-video-poster.svg">Not found footage.</video>;
  }

  return (
    <>
      <div className={classes.videoContent}>
        <video poster="/live-video-poster.svg">
          Sorry, your browser doesn't support embedded videos.
        </video>
        <div className={classes.iframeContent}>
          <iframe
            className={classes.player}
            src={iframeSrc}
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </>
  );
};

export default VehiclePlaybackIframe;
